import { render, staticRenderFns } from "./designSystem.vue?vue&type=template&id=7c26cacc&"
import script from "./designSystem.vue?vue&type=script&lang=js&"
export * from "./designSystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports